import React, {useState} from "react";
import {FilterSquare} from "@App/Components/FilterSquare";
import {MapIcon, SearchIcon, SortIcon} from "@App/Components/common/Icons";
import {FilterButton} from "@App/Components/common/FilterButton";
import {Modal} from "@App/Components/Modal";
import {RadioGroup} from '@headlessui/react'
import {CheckIcon} from '@heroicons/react/solid'
import {useDispatch, useSelector} from "react-redux";
import {bindActionCreators} from "@reduxjs/toolkit";
import {actionCreators, State} from '@App/state'
import {Filters} from "@App/types/enums";
import {useTranslation} from "react-i18next";
import {OrganizationIsArval} from "@App/utils/conditionals/organization";

type MobileFilterProps = {
    filterPlaceOpen: boolean
    filterDateOpen: boolean
    filterServiceOpen: boolean
    filterBrandOpen: boolean
    onChange: (type: Filters) => void
    onChangeMap: (open: boolean) => void
    hasPremiumServices: boolean
}

export const MobileFilter = React.memo<MobileFilterProps>((props: MobileFilterProps) => {

    const {t} = useTranslation()
    const dispatch = useDispatch()
    const {changeSortByFilter} = bindActionCreators(actionCreators, dispatch)
    const sortBy = useSelector((state: State) => state.filters.sortBy)
    const organization = useSelector((state: State) => state.orders.organization)

    const [openSorting, setOpenSorting] = useState(false)

    return (
        <div>
            <div className="grid grid-cols-3 gap-1 mb-3">
                <FilterSquare title="Sortieren" onClick={() => setOpenSorting(true)}>
                    <SortIcon/>
                </FilterSquare>

                {organization.settings.garage_list.filters.includes('search') && (
                    <FilterSquare title="Suche" onClick={() => props.onChange(Filters.Search)}>
                        <SearchIcon/>
                    </FilterSquare>
                )}

                <FilterSquare title="Karte" onClick={() => props.onChangeMap(true)}>
                    <MapIcon/>
                </FilterSquare>
            </div>
            <div className="flex mb-4 overflow-y-auto no-scrollbar">
                {organization.settings.garage_list.filters.includes('place') && (
                    <FilterButton title={"Umgebung"} status={props.filterPlaceOpen}
                                  onChange={() => props.onChange(Filters.Place)}/>
                )}
                {organization.settings.garage_list.filters.includes('date') && (
                    <FilterButton title={"Datum"} status={props.filterDateOpen}
                                  onChange={() => props.onChange(Filters.Date)}/>
                )}
                {organization.settings.garage_list.filters.includes('services') && props.hasPremiumServices && (
                    <FilterButton title={`${OrganizationIsArval(organization) ? "Filter" : "Zusatzservices"}`} status={props.filterServiceOpen}
                                  onChange={() => props.onChange(Filters.Service)}/>
                )}
                {organization.settings.garage_list.filters.includes('brand') && (
                    <FilterButton title={"Marke"} status={props.filterBrandOpen}
                                  onChange={() => props.onChange(Filters.Brand)}/>
                )}
            </div>
            <Modal open={openSorting} onClose={() => setOpenSorting(false)} onClick={() => setOpenSorting(false)}
                   width={'lg'} title="Sortieren nach" buttonText="Werkstattliste sortieren">
                <div>
                    <div className="w-full px-4">
                        <div className="w-full max-w-md mx-auto">
                            <RadioGroup value={sortBy} onChange={(value) => changeSortByFilter(value)}>
                                <RadioGroup.Label className="sr-only">Sortieren nach</RadioGroup.Label>
                                <div className="space-y-2">
                                    {organization.settings.garage_list.sorting.map((sortBy, sortByIdx) => (
                                        <RadioGroup.Option
                                            key={sortByIdx}
                                            value={sortBy}
                                            className={({active, checked}) =>
                                                `${
                                                    active
                                                        ? 'ring-2 ring-offset-2 ring-offset-primary ring-primary ring-opacity-60'
                                                        : ''
                                                }
                                ${
                                                    checked ? 'bg-primary bg-opacity-75 text-neutral-700' : 'bg-neutral-100'
                                                }
                                    relative rounded-lg shadow-md px-5 py-4 cursor-pointer flex focus:outline-none`
                                            }
                                        >
                                            {({checked}) => (
                                                <div
                                                    className="flex items-center justify-between w-full">
                                                    <div className="flex items-center">
                                                        <div className="text-sm">
                                                            <RadioGroup.Label
                                                                as="p"
                                                                className={`font-medium  ${
                                                                    checked ? 'text-white' : 'text-neutral-700'
                                                                }`}
                                                            >
                                                                {t('garageList.sorting.' + sortBy)}
                                                            </RadioGroup.Label>
                                                            <RadioGroup.Description
                                                                as="span"
                                                                className={`inline ${
                                                                    checked ? 'text-neutral-100' : 'text-neutral-500'
                                                                }`}
                                                            >
                                            <span>

                                            </span>{' '}
                                                            </RadioGroup.Description>
                                                        </div>
                                                    </div>
                                                    {checked && (
                                                        <div className="flex-shrink-0 text-neutral-700">
                                                            <CheckIcon/>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </RadioGroup.Option>
                                    ))}
                                </div>
                            </RadioGroup>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
        );
})
